<div class="flex flex-col gap-6">
  <!-- Déclarant du bien / Cadre juridique -->
  <div>
    <!-- Title -->
    <h1 class="text-2xl sm:text-3xl font-extrabold text-gray-12 tracking-tight m-0 leading-tight">
      {{ property().presentation?.title || 'Fiche du bien immobilier' }}
    </h1>

    <!-- Location & Publication Date Meta -->
    <div class="flex flex-wrap items-center gap-y-2 gap-x-4 mt-3 text-sm text-gray-11">
      <span class="flex items-center gap-1.5 font-medium text-gray-12">
        <mat-icon class="text-base! w-4! h-4! text-indigo-9">place</mat-icon>
        {{ property().location?.address?.city || 'Ville non renseignée' }}
        @if (property().location?.address?.zipCode) {
          <span>({{ property().location?.address?.zipCode }})</span>
        }
      </span>

      <span>•</span>

      <span class="flex items-center gap-1.5">
        <mat-icon class="text-base! w-4! h-4! text-gray-9">calendar_today</mat-icon>
        Publiée le {{ property().createdAt | luxonDate: 'dd MMMM yyyy' }}
      </span>

      @if (property().definition?.seller?.role) {
        <span>•</span>
        <span
          class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-indigo-a3 text-indigo-11 border border-indigo-a4"
        >
          <mat-icon class="text-xs! w-3.5! h-3.5!">badge</mat-icon>
          {{ property().definition?.seller?.role | etxeEnumDisplay: 'sellerRole' }}
        </span>
      }
    </div>
  </div>

  <!-- Description du bien -->
  <p class="text-gray-11 text-base leading-relaxed whitespace-pre-line m-0">
    {{
      property().presentation?.description ||
        'Aucune description détaillée n’a été rédigée pour cette annonce.'
    }}
  </p>

  <!-- Big Price Section -->
  <div
    class="flex flex-wrap items-baseline justify-between gap-4 p-5 rounded-2xl bg-indigo-a2/70 border border-indigo-a4"
  >
    <div>
      <span class="text-xs font-bold uppercase tracking-wider text-indigo-11 block mb-1">
        Prix de vente net vendeur souhaité
      </span>
      <div class="flex flex-col items-baseline flex-wrap">
        <div class="text-5xl font-black text-indigo-12 flex items-baseline tracking-tight">
          {{ sellingPriceFormatted() }}
          <span class="text-4xl font-bold ml-1 text-indigo-11">€</span>
        </div>
        @if (pricePerSquareMeterFormatted(); as priceM2) {
          <span class="text-xl font-semibold text-indigo-11/80"> {{ priceM2 }} €/m² </span>
        }
      </div>
    </div>

    <div class="flex flex-col sm:items-end text-xs text-gray-11 gap-1">
      @if (notaryFeesFormatted()) {
        <div class="font-medium text-gray-12">
          Frais de notaire estimés :
          <span class="font-bold text-indigo-11">{{ notaryFeesFormatted() }} €</span>
          @if (notaryFeesPercentageFormatted(); as pct) {
            <span class="text-indigo-11 font-semibold ml-0.5">({{ pct }} %)</span>
          }
        </div>
      }
      @if (property().financials?.chargesCents) {
        <div>
          Charges courantes :
          <span class="font-bold text-gray-12"
            >{{ property().financials?.chargesCents / 100 || 0 | number: '1.0-0' : 'fr-FR' }} €/mois</span
          >
        </div>
      }
    </div>

    <!-- DVF Dedicated Section with Gauge -->
    @if (dvfData(); as dvf) {
      @if (dvf.medianPriceM2) {
        <div class="w-full border-t border-indigo-a4/60 pt-4 mt-2">
          <etxe-property-dvf-gauge
            [currentPriceM2]="currentPriceM2()"
            [medianPriceM2]="dvf.medianPriceM2"
            [minPriceM2]="dvf.minPriceM2"
            [maxPriceM2]="dvf.maxPriceM2"
            [salesCount]="dvf.salesCount"
            [propertyType]="dvf.propertyType"
          />
        </div>
      }
    }
  </div>
</div>
